"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unit = exports.Provider = exports.AttributeType = void 0;
var AttributeType;
(function (AttributeType) {
    AttributeType["NEGATIVE"] = "negative";
    AttributeType["POSITIVE"] = "positive";
    AttributeType["NEUTRAL"] = "neutral";
})(AttributeType || (exports.AttributeType = AttributeType = {}));
var Provider;
(function (Provider) {
    Provider["HAUT"] = "haut";
    Provider["REVIEVE"] = "revieve";
})(Provider || (exports.Provider = Provider = {}));
var Unit;
(function (Unit) {
    Unit["PERCENTAGE"] = "percentage";
    Unit["YEAR"] = "year";
    Unit["ITA"] = "ita";
})(Unit || (exports.Unit = Unit = {}));
const normalized = {
    redness: {
        attribute: 'redness',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT, Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'redness',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
        revieve: {
            attribute: 'Redness',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    perceived_age: {
        attribute: 'perceived_age',
        unit: Unit.YEAR,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.NEUTRAL,
        haut: {
            attribute: 'Perceived Age',
            type: AttributeType.NEUTRAL,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    smoothness: {
        attribute: 'smoothness',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT, Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'uniformness',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
        revieve: {
            attribute: 'smoothness',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    eye_bags: {
        attribute: 'eye_bags',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT, Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'eye_bags',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
        revieve: {
            attribute: 'eyes',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    wrinkles: {
        attribute: 'wrinkles',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT, Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'wrinkles',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
        revieve: {
            attribute: 'Wrinkles',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    lines: {
        attribute: 'lines',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT, Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'lines',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
        revieve: {
            attribute: 'lines',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    eyes_age: {
        attribute: 'eyes_age',
        unit: Unit.YEAR,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.NEUTRAL,
        haut: {
            attribute: 'Eyes Age',
            type: AttributeType.NEUTRAL,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    skin_tone: {
        attribute: 'skin_tone',
        unit: Unit.ITA,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.NEUTRAL,
        haut: {
            attribute: 'Skin Tone',
            type: AttributeType.NEUTRAL,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    pores_face: {
        attribute: 'pores_face',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'pores',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    skin_shine: {
        attribute: 'skin_shine',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'Skin shine',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    acne: {
        attribute: 'acne',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE, Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'acne',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
        haut: {
            attribute: 'acne',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    texture: {
        attribute: 'texture',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'texture',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    radiance: {
        attribute: 'radiance',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'radiance',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    hyperpigmentation: {
        attribute: 'hyperpigmentation',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE, Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'hyperpigmentation',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
        haut: {
            attribute: 'pigmentation',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    melasma: {
        attribute: 'melasma',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'melasma',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    firmness: {
        attribute: 'firmness',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'skin_firmness',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    freckles: {
        attribute: 'freckles',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'freckles',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    dark_spots: {
        attribute: 'dark_spots',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'dark_spots',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    dull_skin: {
        attribute: 'dull_skin',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'dull_skin',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    uneven_skin_tone: {
        attribute: 'uneven_skin_tone',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'uneven_skin_tone',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    pore_dilation: {
        attribute: 'pore_dilation',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'pore_dilation',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
    },
    skin_sagging: {
        attribute: 'skin_sagging',
        unit: Unit.PERCENTAGE,
        providers: [Provider.REVIEVE, Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        revieve: {
            attribute: 'skin_sagging',
            type: AttributeType.NEGATIVE,
            scale: {
                min: 0,
                max: 1,
            },
        },
        haut: {
            attribute: 'sagging',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    translucency: {
        attribute: 'translucency',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'translucency',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    hydration: {
        attribute: 'hydration',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'Hydration',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
};
const haut = {
    algorithm_version_id: {
        '30': normalized.redness.attribute,
        '31': normalized.perceived_age.attribute,
        '32': normalized.smoothness.attribute,
        '33': normalized.eye_bags.attribute,
        '34': normalized.wrinkles.attribute,
        '69': normalized.lines.attribute,
        '35': normalized.pores_face.attribute,
        '36': normalized.acne.attribute,
        '37': normalized.skin_sagging.attribute,
        '39': normalized.hyperpigmentation.attribute,
        '41': normalized.eyes_age.attribute,
        '42': normalized.skin_tone.attribute,
        '50': normalized.translucency.attribute,
        '51': normalized.hydration.attribute,
    },
};
const revieve = {
    attribute: {
        'eyes': normalized.eye_bags.attribute,
        'wrinkles': normalized.wrinkles.attribute,
        'lines': normalized.lines.attribute,
        'redness': normalized.redness.attribute,
        'Skin shine': normalized.skin_shine.attribute,
        'acne': normalized.acne.attribute,
        'texture': normalized.texture.attribute,
        'smoothness': normalized.smoothness.attribute,
        'radiance': normalized.radiance.attribute,
        'hyperpigmentation': normalized.hyperpigmentation.attribute,
        'melasma': normalized.melasma.attribute,
        'freckles': normalized.freckles.attribute,
        'dark_spots': normalized.dark_spots.attribute,
        'dull_skin': normalized.dull_skin.attribute,
        'uneven_skin_tone': normalized.uneven_skin_tone.attribute,
        'pore_dilation': normalized.pore_dilation.attribute,
        'skin_sagging': normalized.skin_sagging.attribute,
        'skin_firmness': normalized.firmness.attribute,
    },
};
exports.default = {
    normalized,
    haut,
    revieve,
};
